export default "__VITE_ASSET__Daqal$Dv__";